// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__1fGa5","footerPlaceholder":"Footer_footerPlaceholder__7hf8f"};